
import React from 'react';

interface EditorButtonProps {
  onClick: () => void;
  icon: React.ReactNode;
  title: string;
  isActive?: boolean;
  disabled?: boolean;
}

const EditorButton = ({ onClick, icon, title, isActive, disabled }: EditorButtonProps) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className={`p-1 rounded transition-colors ${
      isActive 
        ? 'bg-gray-200 text-gray-800 dark:bg-gray-700 dark:text-white' 
        : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
    } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
    title={title}
  >
    {icon}
  </button>
);

export default EditorButton;
